import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AiAgentsIndex from './Index.vue';
import StudioLayout from './studio/StudioLayout.vue';
import OverviewTab from './studio/tabs/OverviewTab.vue';
import PersonaTab from './studio/tabs/PersonaTab.vue';
import PlaygroundTab from './studio/tabs/PlaygroundTab.vue';
import KnowledgeHubTab from './studio/tabs/KnowledgeHubTab.vue';
import ApiRulesTab from './studio/tabs/ApiRulesTab.vue';
import TransferHubTab from './studio/tabs/TransferHubTab.vue';
import SafetyTab from './studio/tabs/SafetyTab.vue';
import BadwordsTab from './studio/tabs/BadwordsTab.vue';
import IntentTab from './studio/tabs/IntentTab.vue';
const aiAgentRouteMeta = {
  featureFlag: FEATURE_FLAGS.AI_BOT,
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_agents_list',
          component: AiAgentsIndex,
          meta: aiAgentRouteMeta,
        },
        {
          path: 'new',
          name: 'ai_agents_new',
          component: AiAgentsIndex,
          meta: aiAgentRouteMeta,
        },
        {
          path: ':botId/studio',
          component: StudioLayout,
          meta: aiAgentRouteMeta,
          children: [
            {
              path: '',
              name: 'ai_agents_studio',
              component: OverviewTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'overview',
              name: 'ai_agents_studio_overview',
              component: OverviewTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'persona',
              name: 'ai_agents_studio_persona',
              component: PersonaTab,
              meta: aiAgentRouteMeta,
            },
            // Old menu entries redirect to the tab that absorbed them.
            {
              path: 'handoff',
              name: 'ai_agents_studio_handoff',
              redirect: { name: 'ai_agents_studio_transfer' },
            },
            {
              path: 'safety',
              name: 'ai_agents_studio_safety',
              component: SafetyTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'badwords',
              name: 'ai_agents_studio_badwords',
              component: BadwordsTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'answers',
              name: 'ai_agents_studio_answers',
              redirect: to => ({
                name: 'ai_agents_studio_knowledge',
                params: to.params,
                query: { view: 'answers' },
              }),
            },
            {
              path: 'api-rules',
              name: 'ai_agents_studio_api_rules',
              component: ApiRulesTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'transfer',
              name: 'ai_agents_studio_transfer',
              component: TransferHubTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'knowledge',
              name: 'ai_agents_studio_knowledge',
              component: KnowledgeHubTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'intent',
              name: 'ai_agents_studio_intent',
              component: IntentTab,
              meta: aiAgentRouteMeta,
            },
            {
              path: 'playground',
              name: 'ai_agents_studio_playground',
              component: PlaygroundTab,
              meta: aiAgentRouteMeta,
            },
          ],
        },
      ],
    },
  ],
};
